import type { CashManagementProviderCredentialsMap } from "../models/ProviderCustomerConfig";

export const PROVIDER_IFX_PAYMENTS = "IFX Payments";
export const PROVIDER_BANKING_CIRCLE = "Banking Circle";
export const PROVIDER_ISX_FINANCIAL = "ISX Financial";
export const PROVIDER_CLEAR_JUNCTION = "Clear Junction";
export const PROVIDER_B4B = "B4B Payments";

export const CM_CONFIGURABLE_PROVIDERS = [
  PROVIDER_IFX_PAYMENTS,
  PROVIDER_ISX_FINANCIAL,
  PROVIDER_CLEAR_JUNCTION,
];
export type CashManagementConfigurableProvider =
  | typeof PROVIDER_IFX_PAYMENTS
  | typeof PROVIDER_ISX_FINANCIAL
  | typeof PROVIDER_CLEAR_JUNCTION;

export type SelectFieldOption = { label: string; value: string };

export type CredentialFields<T extends CashManagementConfigurableProvider> = {
  [P in keyof CashManagementProviderCredentialsMap[T]]: {
    name: keyof CashManagementProviderCredentialsMap[T];
    required: boolean;
    fieldType: "normal" | "secret" | "copy" | "select";
    fieldOptions?: SelectFieldOption[];
  };
};

export type RISK_SCORE_OPTION = "LOW_RISK" | "HIGH_RISK";

export const RISK_SCORE_OPTIONS = {
  low: "LOW_RISK",
  high: "HIGH_RISK",
} as const;

export const RISK_SCORE_OPTIONS_LABEL = {
  [RISK_SCORE_OPTIONS.low]: "lowRisk",
  [RISK_SCORE_OPTIONS.high]: "highRisk",
};

export const CM_PROVIDERS_CREDENTIAL_FIELDS: {
  [K in CashManagementConfigurableProvider]: CredentialFields<K>;
} = {
  [PROVIDER_IFX_PAYMENTS]: {
    clientId: { name: "clientId", fieldType: "copy", required: false },
    clientSecret: {
      name: "clientSecret",
      fieldType: "secret",
      required: false,
    },
    username: { name: "username", fieldType: "normal", required: false },
    password: { name: "password", fieldType: "secret", required: false },
    notificationSecret: {
      name: "notificationSecret",
      fieldType: "secret",
      required: true,
    },
  },
  [PROVIDER_ISX_FINANCIAL]: {
    notificationSecret: {
      name: "notificationSecret",
      fieldType: "secret",
      required: true,
    },
  },
  [PROVIDER_CLEAR_JUNCTION]: {
    riskScore: {
      name: "riskScore",
      required: true,
      fieldType: "select",
      fieldOptions: [
        {
          label: RISK_SCORE_OPTIONS_LABEL[RISK_SCORE_OPTIONS.low],
          value: RISK_SCORE_OPTIONS.low,
        },
        {
          label: RISK_SCORE_OPTIONS_LABEL[RISK_SCORE_OPTIONS.high],
          value: RISK_SCORE_OPTIONS.high,
        },
      ],
    },
  },
};
